export default __webpack_public_path__ + "3156d86148fd918121dd8b579e90cd0d.webp";